import React from 'react';
import { PageLayout, PageTitle, Project } from '../components';
import { SEO } from '../utils';
import Container from 'react-bootstrap/Container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default () => {
  return (
    <PageLayout>
      <SEO title="Hackathons, Project" />
      <PageTitle title="Hackathons" />
      <Container className="text-left">
        <section style={{ marginBottom: '2rem' }}>
          <Project
            title="Microsoft India Innovation series - Winner"
            affiliation="Microsoft | Incubate Ind"
            from="June 2020"
            // to="Oct 2019"
            tags={['Tensorflow', 'Dlib', 'Python', 'Django', 'Heroku', 'Android', 'OpenGL']}
          >
            <p style={{ marginBottom: '0.5rem' }}>
              Under the open-innovation theme, my team designed a novel approach to convert 2D facial images to 3D images
              by implementing Position Map Regression Networks(PRnet) and further used the concept to create animated faces
              in the wild for character animation in real time RPG Games. I implemented the PRnet and worked on developing a
              OpenGL based framework for Android to project the 3D faces.
            </p>
            <div>
              <a href="https://github.com/dhruv-rathi-zomato/iis-ms-del/tree/master/Team_21_Bandersnatch" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon
                  icon={['fab', 'github']}
                  className="icons github"
                  title="Github"
                  style={{ fontSize: '2rem' }}
                />
              </a>
            </div>
          </Project>

          <Project
            title="3Defy - Microsoft Mishmash Hackathon - Winner"
            affiliation="Microsoft | Skillenza"
            from="Jan 2020"
            tags={['Tensorflow', 'Keras', 'Unity', 'Android', 'OpneGL', 'Amazon Mechanical Turk', 'Python']}
          >
            <p style={{ marginBottom: '0.5rem' }}>
              Automatic creation of Interactive 3D Unity Assets of each segmented object(ex- Human face, 
              human body, furniture, TV, Car, pets, etc) from a live camera clicked 2D image 
              using Deep Learning.
            </p>
            <div>
              <a href="https://github.com/skillenza-com/MishMash-India-2020/issues/203i" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon
                  icon={['fab', 'github']}
                  className="icons github"
                  title="Github"
                  style={{ fontSize: '2rem' }}
                />
              </a>
            </div>
          </Project>

          <Project
            title="HackaNoodle - Hackathon by Zomato - Winner | Full time offer"
            affiliation="Zomato"
            from="December 2018"
            to="Present"
            tags={['OpenCV', 'Dlib', 'Android', 'Physics', 'Optics']}
          >
            <p style={{ marginBottom: '0.5rem' }}>
              Measuring Eye Lens power with a smartphone and eradicating the use of lensometer machines and 
              external dependencies while using a mechanism similar to the machine on a smartphone utilizing
              Deep Learning principles. Our team worked together on developing an equation to calculate and 
              measure the power of eye lens after in-depth and rigorous research in Optics and biology to 
              utilize the focal data received from the models to calculate the power of the eye lens.
            </p>
          </Project>

          <Project
            title="Hack The North 2018 - Winner"
            affiliation="The University of Waterloo, Canada"
            from="Sep 2018"
            to="Present"
            tags={['Tensorflow', 'OpenCV', 'Android', 'Python', 'JAVA']}
          >
            <p style={{ marginBottom: '0.5rem' }}>
              Using two 360-degree GoPros, FitBit and Deep Learning, our team developed a novel solution to detect
              enemy attack for soldiers in the field and detect incoming enemies and alert the control and the soldier.
              Presented to the Royal Canadian Navy.
            </p>
          </Project>

          <Project
            title="Vihaan ’17 Hackathon - Winner | Facial Paralysis"
            affiliation="IEEE"
            from="October 2017"
            tags={['Computer Vision', 'Tensorflow', 'Biology', 'JAVA', 'Android', 'Python']}
          >
            <p style={{ marginBottom: '0.5rem' }}>
              I developed a novel solution, for which I currently hold the patent. 
              I developed a method to detect, quantify, track and diagnose facial paralysis deseases such as Bell's Palsy,
              Ramsay Hunt's Syndrome and others. Received media coverage in Business Standard, Economic Times and others.
            </p>
          </Project>

          <Project
            title="Campus Shark Hackathon - 1st Runner up"
            affiliation="Digital Ocean"
            from="Aug 2017"
            tags={['Android', 'Firebase', 'Parse DB']}
          >
            <p style={{ marginBottom: '0.5rem' }}>
              Developed an app for old age people for universal accessibility and on-demand help among other features(which
              I honestly not able to recall :p).
            </p>
          </Project>

          <Project
            title="India Smart Grid Week Hackathon 2017 - Nation Wide Runner Up"
            affiliation="Government of India"
            from="Jun 2017"
            tags={['Physics', 'IoT', 'Android', 'Machine Learning']}
          >
            <p style={{ marginBottom: '0.5rem' }}>
              Our team developed an Internet of Things(IoT) enabled online and offline smart grid management system for the
              Government of India.
            </p>
          </Project>

        </section>
      </Container>
    </PageLayout>
  );
};
